export default {
  "content": "<path d=\"M12 4.5H6.5V20h11V10h2v10a2 2 0 01-2 2h-11a2 2 0 01-2-2V4.5a2 2 0 012-2H12v2z\" fill=\"#7B61FF\"/><path d=\"M14 4a4 4 0 014 4h-2a2 2 0 00-2-2V4z\" fill=\"#7B61FF\"/><path d=\"M14 0a8 8 0 018 8h-2a6 6 0 00-6-6V0z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};